/**
 * @generated SignedSource<<25caf074dd4c2c5dc637ec3f097d2738>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type optimisticUpdatesSelectedOptionsQuery$data = {
  readonly edges: ReadonlyArray<{
    readonly fieldSets?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly fields: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly __typename: string;
                readonly fieldId: string;
                readonly selectedOptions?: {
                  readonly edges: ReadonlyArray<{
                    readonly __id: string;
                    readonly node: {
                      readonly id: string;
                      readonly value: string | null | undefined;
                    } | null | undefined;
                  } | null | undefined> | null | undefined;
                } | null | undefined;
                readonly type: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "optimisticUpdatesSelectedOptionsQuery";
};
export type optimisticUpdatesSelectedOptionsQuery$key = {
  readonly " $data"?: optimisticUpdatesSelectedOptionsQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"optimisticUpdatesSelectedOptionsQuery">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "optimisticUpdatesSelectedOptionsQuery"
};

(node as any).hash = "7520e5d2b6b73d5bb8295c067a5f6f72";

export default node;
